import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FormInputConfig } from '../../../../../trash/shared/interfaces/form-input-config';
import { DialogModule } from 'primeng/dialog';
import { FormComponent } from '../../../../../trash/shared/components';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { SidebarModule } from 'primeng/sidebar';

@Component({
  selector: 'app-filter',
  standalone: true,
  imports: [ButtonModule, DropdownModule, SidebarModule, CommonModule, FormsModule, FormComponent, DialogModule],
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss'
})
export class FilterComponent {
  @Input() visible: boolean = false;
  @Input() filterOptions: FormInputConfig[] = [];
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() applyFilter = new EventEmitter<any>();
  @Output() clearFilter = new EventEmitter<void>();

  form: FormInputConfig[] = [];
  formValues: any = null;
  validationEmit = false;
  validationErrors: any = {};

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    if (this.filterOptions) {
      this.form = [...this.filterOptions];
    }
  }

  onApply(e?: any) {
    this.applyFilter.emit(e);
    this.closeSidebar();
  }

  valueChanged(data: any) {
    this.formValues = { ...data };
  }

  emitValidation() {
    this.validationEmit = !this.validationEmit;
    this.cdr.detectChanges();
  }

  onClear() {
    this.clearFilter.emit();
  }

  closeSidebar() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }
}
